module.exports = __webpack_public_path__ + "static/media/byu-logo.8c826474.png";